const IdMeCheckMark = ({ className }) => {
  return (
    <svg className={`ml-4 ${className}`} width="16" height="11" viewBox="0 0 16 11" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.92259 5.24408C1.59715 4.91864 1.06951 4.91864 0.744078 5.24408C0.418641 5.56952 0.418641 6.09715 0.744078 6.42259L4.91074 10.5893C5.23618 10.9147 5.76382 10.9147 6.08926 10.5893L15.2559 1.42259C15.5814 1.09715 15.5814 0.569515 15.2559 0.244078C14.9305 -0.0813592 14.4028 -0.0813592 14.0774 0.244078L5.5 8.82149L1.92259 5.24408Z"
        fill="#008600"
      />
    </svg>
  );
};

IdMeCheckMark.propTypes = {
  className: PropTypes.string,
};

export default IdMeCheckMark;
